import { Component, OnInit, Renderer2 } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';
import { AuthService } from './core/auth.service';
import { ConfigService } from './core/config.service';
import { MaintenanceService } from './core/maintenance.service';
import { ScriptService } from './services/script/script.service';

import de from '../assets/config/de.json';

@Component({
  selector: 'app-root',
  template: `
    <app-maintenance
      *ngIf="isUnderMaintenance; else normalContent"
    ></app-maintenance>
    <ng-template #normalContent>
      <router-outlet></router-outlet>
    </ng-template>
    <p-toast position="top-right"></p-toast>
  `,
})
export class AppComponent implements OnInit {
  isUnderMaintenance = false;

  constructor(
    private primengConfig: PrimeNGConfig,
    private renderer: Renderer2,
    authService: AuthService,
    private configService: ConfigService,
    private scriptService: ScriptService,
    private maintenanceService: MaintenanceService,
  ) {
    this.maintenanceService.checkMaintenanceStatus().subscribe({
      next: (isUnderMaintenance) => {
        this.isUnderMaintenance = isUnderMaintenance;

        if (!isUnderMaintenance) {
          this.initializeApp(authService);
        }
      },
      error: (error) => {
        console.error('Failed to check maintenance status:', error);
        this.initializeApp(authService);
      },
    });
  }

  private initializeApp(authService: AuthService): void {
    this.configService.getConfig().subscribe((config) => {
      if (config) {
        this.scriptService.loadJsScript(
          this.renderer,
          config.keycloakConfig.authServerUrl +
            '/js/keycloak-authz.js',
        ).onload = () => {
          authService.runInitialLoginSequence().subscribe();
        };
      } else {
        authService.runInitialLoginSequence().subscribe();
      }
    });
  }

  ngOnInit(): void {
    this.primengConfig.ripple = true;
    this.primengConfig.setTranslation(de.de);
  }
}
